import React from 'react'
import { Location } from 'history'

// Constants
import { RouteProps, routes, SKETCH_WEBSITE } from '@sketch/constants'

// Hooks
import { getIsForInAppPresentation } from 'modules/user/hooks/useSketchSource/useSketchSource'

// Components
import IndexLayout, { Title, Subtitle } from 'components/IndexLayout'
import { Link } from '@sketch/components'

import SsoSignInForm from './SsoSignInForm'

// Utils
import { useQueryParams } from 'utils'
import { sourceToSsoSignInSource } from '../../operations'

// Styles
import {
  SsoInformationAndFaqWrapper,
  StyledLink,
  Wrapper,
  Text,
  Line,
} from './SsoSignInView.styles'

const SsoSignInView: React.FC<RouteProps<'SSO_SIGN_IN'>> = props => {
  const { state } = props.location as Location<{ from?: Location }>
  const { source = 'cloud', team, shortname } = useQueryParams<'SSO_SIGN_IN'>()

  const isForInAppPresentation = getIsForInAppPresentation()

  const teamName = team || shortname
  const formSource = isForInAppPresentation
    ? 'sketch'
    : sourceToSsoSignInSource[source] ?? 'cloud'
  const target = isForInAppPresentation ? '_self' : '_blank'

  return (
    <IndexLayout
      headerLink="none-with-border"
      blockLogoLink={isForInAppPresentation}
      variant="orange"
    >
      <Wrapper>
        <Title>Enter SSO Shortname</Title>
        <Subtitle>
          Enter your Workspace&apos;s single sign-on (SSO) name
        </Subtitle>
        <SsoSignInForm
          source={formSource}
          teamName={teamName}
          from={state?.from?.pathname}
        />
        <SsoInformationAndFaqWrapper>
          <StyledLink
            href={`${SKETCH_WEBSITE}/support/business-plan/what-is-sso/`}
            target={target}
            rel="noopener noreferrer"
            variant="primary"
            isUnderlined
            external
          >
            How Single Sign-On (SSO) works
          </StyledLink>
          {!isForInAppPresentation && (
            <>
              <StyledLink
                variant="primary"
                isUnderlined
                to={{ pathname: routes.SIGN_IN.create({}), state }}
              >
                Sign in with email and password
              </StyledLink>
              <Line />
              <Text>
                New to Sketch?{' '}
                <Link
                  variant="primary"
                  isUnderlined
                  to={{
                    pathname: routes.SIGN_UP.create({}),
                    state,
                  }}
                >
                  Create an account
                </Link>
              </Text>
            </>
          )}
        </SsoInformationAndFaqWrapper>
      </Wrapper>
    </IndexLayout>
  )
}

export default SsoSignInView
